import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { IInvoice } from '@hooks/useMemberInvoice';

import { keysToCamel } from '@utils/butter';

import NewBillCard, { INewBillCardWrapperContent } from './NewBillCard.component';

interface INewBillCardWrapperProps {
	bill: IInvoice;
	className?: string;
	handleClick?: () => void;
}

const NewBillCardWrapper: FC<INewBillCardWrapperProps> = ({ bill, className, handleClick }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "new-bill-card" }) {
				disclaimer_copy
				pay_now_label
			}
		}
	`);

	const refinedContent: INewBillCardWrapperContent = keysToCamel(
		pageContent
	) as INewBillCardWrapperContent;

	return (
		<NewBillCard
			bill={bill}
			wrapperContent={refinedContent}
			className={className}
			handleClick={handleClick}
		/>
	);
};

export default NewBillCardWrapper;
